const state = {
  processing: false,
  taxes: [],
  showTaxes: false,
  importResult: null,
  page: 1,
  pageSize: 10,
  totalItems: 0,
  totalPages: 0,
};
export default state;
